import React, {useEffect, useState} from 'react';
import styles from "../../assets/stylesheets/sass/Code.module.scss";

export default function LoadingContainer(children){
  const [defaultHide, setdefaultHide] = useState(false);

  useEffect(()=>{
    if(typeof(children.hide) === "boolean"){
      setdefaultHide(children.hide)
    }
  }, [children.hide])
  return (
    <>
    {!defaultHide &&
    <div className={styles.popup_container}>
        {children.children}
    </div>
    }
    </>
  )
}